import ROUTES from '../routes';
import GeneralLedgerTransactions from '../hoc/general-ledger/general-ledger';
import GeneralLedgerTransaction from '../hoc/general-ledger/transaction';
import TransactionFee from '../hoc/general-ledger/transaction-fee/transaction-fee';
import TransactionFeeGeneral from '../hoc/general-ledger/transaction-fee/transaction-fee-general';
import TransactionFeeChangeLog from '../hoc/general-ledger/transaction-fee/transaction-fee-change-log';
import TransactionFeeLog from '../hoc/general-ledger/transaction-fee/transaction-fee-log';
import TransactionFeeWarnings from '../hoc/general-ledger/transaction-fee/transaction-fee-warnings';

const GeneralLedgerRoutes = {
  path: ROUTES.GENERAL_LEDGER,
  element: <GeneralLedgerTransactions />,
  children: [
    {
      path: ROUTES.GENERAL_LEDGER_CREATE,
      element: <GeneralLedgerTransaction />,
    },
    {
      path: ROUTES.GENERAL_LEDGER_READ,
      element: <GeneralLedgerTransaction />,
    },
    {
      path: ROUTES.GENERAL_LEDGER_FEE,
      element: <TransactionFee />,
      children: [
        {
          path: ROUTES.GENERAL_LEDGER_FEE_WARNING,
          element: <TransactionFeeWarnings />,
        },
        {
          path: ROUTES.GENERAL_LEDGER_FEE_GENERAL,
          element: <TransactionFeeGeneral />,
        },
        {
          path: ROUTES.GENERAL_LEDGER_FEE_LOG,
          element: <TransactionFeeLog />,
        },
        {
          path: ROUTES.GENERAL_LEDGER_FEE_CHANGE_LOG,
          element: <TransactionFeeChangeLog />,
        },
      ],
    },
  ],
};

export default GeneralLedgerRoutes;
